// return the user data from the session storage
export const getUser = () => {
  const userStr = sessionStorage.getItem('user');
  if (userStr) return JSON.parse(userStr);
  else return null;
}
export const getUserId = () => {
  const userStrId = sessionStorage.getItem('userId');
  if (userStrId) return JSON.parse(userStrId);
  else return null;
}
export const getPointId = () => {
  const pointStrId = sessionStorage.getItem('pointId');
  if (pointStrId) return JSON.parse(pointStrId);
  else return null;
}

export const getDate = () => {
  const dateStr = sessionStorage.getItem('currentdate');
  if (dateStr) return JSON.parse(dateStr);
  else return null;
}
export const getErrorStatusSession = () => {
  const status = sessionStorage.getItem('statuscode');
  if (status) return JSON.parse(status);
  else return null;
}
export const getplaceSession = () => {
  const place = sessionStorage.getItem('place');
  if (place) return JSON.parse(place);
  else return null;
}
export const getUserTypeSession = () => {
  const userType = sessionStorage.getItem('userType');
  if (userType) return JSON.parse(userType);
  else return null;
}

// return the token from the session storage
export const getToken = () => {
  return sessionStorage.getItem('token') || null;
}

// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('user');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('currentdate');
  sessionStorage.removeItem('pointId');
  sessionStorage.removeItem('statuscode');
  sessionStorage.removeItem('place');
  sessionStorage.removeItem('userType');
}

// set the token and user from the session storage
export const setUserSession = (token, user) => {
  // console.log("Athenticate call token "+JSON.stringify(token));
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('user', JSON.stringify(user));
}
export const setUserName = (user) => {
  sessionStorage.setItem('user', JSON.stringify(user));
}
export const setloginSession = (userId, currentdate) => {
  sessionStorage.setItem('userId', JSON.stringify(userId));
  sessionStorage.setItem('currentdate', JSON.stringify(currentdate));
}
export const setloginPointIdSession = (pointid) => {
  sessionStorage.setItem('pointId', JSON.stringify(pointid));
}
export const setErrorStatusSession = (status) => {
  sessionStorage.setItem('statuscode', JSON.stringify(status));
}
export const setUserPlaceSession = (place) => {
  sessionStorage.setItem('place', JSON.stringify(place));
}
export const setUserTypeSession = (userType) => {
  sessionStorage.setItem('userType', JSON.stringify(userType));
}

 
